import React from 'react';

import SecondaryFilterFormSkeleton from 'search/filters/base/SecondaryFilterFormSkeleton';
import {SingleValueFilter} from 'search/SearchConstants';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

interface ProcessTaskHasFailedMappingsFilterFormProps extends BaseFilterFormProps {
  filter: SingleValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: SingleValueFilter) => void;
  onChangeValue: (e: string) => void;
  onRemove: () => void;
}

export default function ProcessTaskHasFailedMappingsFilterForm(
  props: ProcessTaskHasFailedMappingsFilterFormProps
): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <SecondaryFilterFormSkeleton
      {...skeletonProps}
      nodeGrid={[[]]}
      onChangeFilterKey={props.onChangeFilterKey}
      selectedFilterKey={props.selectedFilterKey}
      onRemove={props.onRemove}
    />
  );
}
